import Splide from "@splidejs/splide";
import { PublicCommunityLI, PublicCommunityLIData }
	from "../../web/src/community/PublicCommunityLI";
import { Templates } from "../../web/src/ui/Templates";
import { AppSettings, getIndexPageUi, QueryParams }
	from "../../web/src/settings/AppSettings";
import { HttpUtils } from "ts_utils";

const infoVideoLI = `
<div class="stscr-iv-videoLI">
	<div class="videoLI-title">
		Bonnie at Morn
	</div>
</div>
`;

const introVids = [
	{
		"name": "Brass Ensemble with One Euphonium",
		"id": "MTZMTCnQexg",
		"lcAppIds": [0]
	},
	{
		"name": "Renaissance Ensemble with Soprano Recorder",
		"id": "O1_BAn3CFFs",
		"lcAppIds": [0]
	},
	{
		"name": "Looping Hot Cross Buns on Trumpet",
		"id": "6J8U2M2lVTo",
		"lcAppIds": [0]
	},
	{
		"name": "Easy Recorder Loop - Waltz in the Shadows",
		"id": "6sDpu2el1DI",
		"lcAppIds": [0]
	},
	{
		"name": "Euphonium - Courtly Masking Ayres no. 8",
		"id": "mjo-gs9fGU0",
		"lcAppIds": [0]
	},
	{
		"name": "Quick Trumpet Loop with Some Improv",
		"id": "LdNvfvMKCl4",
		"lcAppIds": [0]
	},
	{
		"name": "Playing Together Live - Celtic Music",
		"id": "ojeqGKzrwgc",
		"lcAppIds": [0]
	},
	{
		"name": "Pachelbel's Canon, Soprano Recorder",
		"id": "lNolZz0FoTE",
		"lcAppIds": [0]
	},
	{
		"name": "Beginner Trumpet Looping",
		"id": "QoV95pNL7Eo",
		"lcAppIds": [0]
	},
	{
		"name": "Hot Cross Buns 2 Looped on Trumpet",
		"id": "-0WxknEiqNU",
		"lcAppIds": [0]
	},
	{ 
		"name": "Collab - Old MacDonald",
		"id": "wv59j27V5OA",
		"lcAppIds": [0]
	},
	
	////////RECORDER PAGE VIDEOS//////////
	{
		"name": "Easy Recorder Loop - Waltz in the Shadows",
		"id": "6sDpu2el1DI",
		"lcAppIds": [1]
	},
	{
		"name": "Looping Hot Cross Buns on Recorder",
		"id": "2Y6O2hky6G0",
		"lcAppIds": [1]
	},
	{
		"name": "Renaissance Ensemble with Recorder",
		"id": "O1_BAn3CFFs",
		"lcAppIds": [1]
	},
	{
		"name": "Pink Recorder Improv",
		"id": "mV3YSOmc0tE",
		"lcAppIds": [1]
	},
	{
		"name": "Pachelbel's Canon Looped with Recorder",
		"id": "lNolZz0FoTE",
		"lcAppIds": [1]
	},
	{ 
		"name": "Collab - Old MacDonald",
		"id": "wv59j27V5OA",
		"lcAppIds": [1]
	},
	// {
	// 	"name": "Soprano Recorder Renaissance Ensemble",
	// 	"id": "AgKgfE93pVM",
	// 	"lcAppIds": [1]
	// },
	// {
	// 	"name": "LoopCollab Tutorial - Recorder Hot Cross Buns",
	// 	"id": "SMrfjlwkmqk",
	// 	"lcAppIds": [1]
	// },
];

const iframeString = `
	<iframe src=""
		title="YouTube video player"
		frameborder="0"
		allow="accelerometer; autoplay; clipboard-write; encrypted-media;"
		allowfullscreen>
	</iframe>
`;



export class IndexPage {
	private _signinBtnDiv:HTMLDivElement;
	private _signinGuestBtnDiv:HTMLDivElement;
	
	private _debugDuplicateCommunities:boolean = false;
	
	constructor(){
		if (AppSettings.allowSignin){
			this._initSigninApp();
		}
		else {
			this._initNoSigninApp();
		}
	}
	
	private _initSigninApp(){
		AppSettings.init();
		
		this._ensureChrome();
		
		let ui = getIndexPageUi();

		this._signinBtnDiv = ui.querySelector("#stscr-signinBtnDiv");
		this._signinBtnDiv.addEventListener("click", this._onSignInClick);

		this._signinGuestBtnDiv = ui.querySelector("#stscr-signinGuestBtnDiv");
		this._signinGuestBtnDiv.addEventListener("click",
			this._onSignInGuestClick);


		this._parseQueryParams();
		this._setupCommunities();
		this._setUpIntroVideos();
		
		if (AppSettings.allowGuests){
			ui.classList.add("showGuest");
			this._signinBtnDiv.innerText = "Sign In";
		}
		
		if (AppSettings.jumpToCheckout){
			this._onSignInClick(null);
		}
	}
	
	private _initNoSigninApp():void {
		AppSettings.init();
		
		this._ensureChrome();
		
		let ui = getIndexPageUi();
		
		this._signinBtnDiv = ui.querySelector("#stscr-signinBtnDiv");
		this._signinBtnDiv.addEventListener("click", this._onSkipSigninClick);
		
		//not used, but populated for object reference.
		this._signinGuestBtnDiv = ui.querySelector("#stscr-signinGuestBtnDiv");
		
		this._parseQueryParams();
		this._setUpIntroVideos();
	}
	
	private _ensureChrome(){
		AppSettings.chooseBestAudioSettings();
		AppSettings.chooseBestVideoSettings();
		
		if (!AppSettings.isAudioSupported){
			let warning = document.querySelector("#stscr-audioWarning") as
				HTMLDivElement;
			warning.style.display = "block";
			
			if (AppSettings.failOnNoAudioSupport){
				let signinDiv = document.querySelector("#stscr-signinDiv") as
					HTMLDivElement;
				signinDiv.style.display = "none";
			}
		}
		else if (!AppSettings.isVideoSupported){
			let warning = document.querySelector("#stscr-videoWarning") as
				HTMLDivElement;
			warning.style.display = "block";
			
			if (AppSettings.failOnNoVideoSupport){
				let signinDiv = document.querySelector("#stscr-signinDiv") as
					HTMLDivElement;
				signinDiv.style.display = "none";
			}
		}
		// else if ((!AppSettings.isUsingPreferredAudio ||
		// 		!AppSettings.isUsingPreferredVideo) &&
		// 		AppSettings.allowSessions){
		// 	let warning = document.querySelector("#stscr-preferWarning") as
		// 		HTMLDivElement;
		// 	warning.style.display = "block";
		// }
	}
	
	private _parseQueryParams(){
		let queryParams = HttpUtils.parseQueryString(window.location.search) as
			QueryParams;
		
		window["params"].queryParams = queryParams;
		
		if (Object.keys(queryParams).length > 0){
			let newUrl = window.location.href.split("?")[0];
			window.history.replaceState({}, document.title, newUrl);
		}
		if (queryParams.mode === "resetPassword" ||
				queryParams.mode === "recoverEmail" ||
				queryParams.mode === "verifyEmail" ||
				queryParams.skipToSignin === "1"){
			this._onSignInClick(null);
			document.getElementById("stscr-appContainer").scrollIntoView();
		}
	}
	
	private _setupCommunities():void {
		let splide = new Splide(".splide", {
			padding: "45px",
			autoWidth: true,
			gap: "20px",
			pagination: false,
			// type: "loop",
			// rewind: false
		});
		splide.mount();
		
		let communities = window["publicCommunityLIData"] as
			PublicCommunityLIData[];
		if (communities.length > 0 && this._debugDuplicateCommunities){
			communities[0].name = "The Bright Trumpets Community";
			while (communities.length < 10){
				communities.push(communities[0]);
			}
		}
		let items:PublicCommunityLI[] = [];
		communities.forEach(data => {
			let li = new PublicCommunityLI(data);
			splide.add(li.ui);
			items.push(li);
		});
		window["publicCommunityListItems"] = items;
		
		if (communities.length > 0){
			let coms = document.querySelector("#stscr-findACommunity") as
				HTMLDivElement;
			coms.style.display = "block";
		}
	}
	
	private _setUpIntroVideos():void {
		let videoListItems = [];

		let vidListDiv = document.querySelector("#stscr-iv-videoList");
		let introVidPlaceholderImg = document.querySelector(
			"#stscr-iv-left img") as HTMLImageElement;
		for (let vid of introVids){
			if (!vid.lcAppIds.includes(AppSettings.lcAppId)){
				continue;
			}
			let li = Templates.createDiv(infoVideoLI);
			li.querySelector(".videoLI-title").innerHTML = vid.name;
			li.setAttribute("data-id", vid.id);
			vidListDiv.append(li);
			li.addEventListener("click", (e) => {
				videoListItems.forEach(vli =>
					vli.classList.remove("currentVid"));
				
				li.classList.add("currentVid");
				introVidPlaceholderImg.style.display = "none";
				
				let iframe = document.querySelector("#stscr-iv-left iframe") as
					HTMLIFrameElement;
				iframe.style.display = "block";
				iframe.src = "https://www.youtube.com/embed/" + vid.id +
					"?autoplay=1";
			});
			videoListItems.push(li);
		}

		introVidPlaceholderImg.addEventListener("click", (e) => {
			videoListItems[0].click();
		});

		// INFORMATION-SECTION VIDEOS
		
		let videoItems = [... document.querySelectorAll(".stscr-is-videoItem")];
		videoItems.forEach((vi) => {
			let ytId = vi.getAttribute("data-vidId");
			let callback = (e) => {
				this._onVideoItemClick(vi, ytId, callback);
			}
			vi.addEventListener("click", callback);
		});
	}
	
	private _onVideoItemClick = (videoItem, youTubeId, callback) => {
		videoItem.removeEventListener("click", callback);
		let ytPreviewImg = videoItem.querySelector("img");
		ytPreviewImg.remove();
		videoItem.innerHTML = iframeString;
		let iframe = videoItem.querySelector("iframe");
		iframe.src = "https://www.youtube.com/embed/" + youTubeId +
			"?autoplay=1";
	}
	
	private _onSignInClick = (e:MouseEvent) => {
		window["params"].tryAsGuest = false;
		this._removeListeners();
		this._signIn();
	}
	
	private _onSignInGuestClick = (e:MouseEvent) => {
		window["params"].tryAsGuest = true;
		this._removeListeners();
		this._signIn();
	}
	
	private _onSkipSigninClick = (e:MouseEvent) => {
		this._removeListeners();
		this._skipSignin();
	}
	
	private _signIn():void {
		let signinDiv = document.getElementById("stscr-signinDiv");
		signinDiv.classList.add("hideSigninBtns");
		
		let busyDiv = document.querySelector("#stscr-signinBusyDiv") as
			HTMLDivElement;
		busyDiv.style.display = "block";
		
		let script = document.createElement("script");
		script.type = "text/javascript";
		script.src = window["params"].resourcesUrl +
			`main.js?v=${window["params"].appVersion}`;
		document.body.append(script);
	}
	
	private _skipSignin():void {
		let signinDiv = document.getElementById("stscr-signinDiv");
		signinDiv.classList.add("hideSigninBtns");
		
		let busyDiv = document.querySelector("#stscr-signinBusyDiv") as
			HTMLDivElement;
		busyDiv.style.display = "block";
		
		let script = document.createElement("script");
		script.type = "text/javascript";
		script.src = window["params"].resourcesUrl +
			`main.js?v=${window["params"].appVersion}`;
		document.body.append(script);
	}
	
	private _removeListeners():void {
		this._signinBtnDiv.removeEventListener("click", this._onSignInClick);
		this._signinGuestBtnDiv.removeEventListener("click",
			this._onSignInGuestClick);
		this._signinBtnDiv.removeEventListener("click",
			this._onSkipSigninClick);
	}
}



new IndexPage();